import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#add_visit_info",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Add Program Info")
  ])
], -1)
const _hoisted_3 = {
  id: "add_visit_info",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Resource Type", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Resource Name", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Email"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    name: "",
    class: "form-control"
  })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Mobile"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    name: "",
    class: "form-control"
  })
], -1)
const _hoisted_16 = { class: "row mt-3" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Gender", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Resource Entity", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "col-md-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Resource Institute", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { class: "col-md-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Desigantion", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Organization(External)"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      name: "",
      class: "form-control"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Sponsoring Association(Ex)"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      name: "",
      class: "form-control"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Organising Entity"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      name: "",
      class: "form-control"
    })
  ])
], -1)
const _hoisted_30 = { class: "card mb-5 mb-xl-10" }
const _hoisted_31 = { class: "card-body border-top p-9" }
const _hoisted_32 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Type", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = { class: "col-md-3" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Name", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = { class: "col-md-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Trade", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = { class: "col-md-3" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Sector", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = { class: "row mt-3" }
const _hoisted_47 = { class: "col-md-3" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Package", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    name: "",
    class: "form-control"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[12] || (_cache[12] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Type of Resource",
                      modelValue: _ctx.batch.resource_type,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.resource_type) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Resource-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Resource-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Resource-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Resource-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Resource-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Resource-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Resource-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Resource-1")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Resource",
                      modelValue: _ctx.batch.resource,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.resource) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "visitor-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Visitor-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "visitor-2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Visitor-2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "visitor-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Visitor-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "visitor-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Visitor-1")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _hoisted_14,
                  _hoisted_15
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _hoisted_19,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Gender",
                      modelValue: _ctx.batch.gender,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.gender) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Male",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Male")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Female",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Female")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _hoisted_22,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Resource Entity",
                      modelValue: _ctx.batch.resource_entity,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.resource_entity) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Resource Entity-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Resource Entity-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Resource Entity-2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Resource Entity-2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Resource Entity-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Resource Entity-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Resource Entity-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Resource Entity-1")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _hoisted_25,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select resource institute",
                      modelValue: _ctx.batch.resource_institute,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.resource_institute) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Resource Institute-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Resource Institute-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Resource Institute-2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Resource Institute-2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Resource Institute-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Resource Institute-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Resource Institute-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Resource Institute-1")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _hoisted_28,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Type of Visitor",
                      modelValue: _ctx.batch.designation,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.designation) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Designation1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Designation1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Designation1",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Designation1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Designation1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Designation1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Designation1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Designation1")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _hoisted_29
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _hoisted_36,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Typeof Training",
                  modelValue: _ctx.batch.training_type,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.batch.training_type) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Training Type-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Type-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Training Type-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Type-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Training Type-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Type-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Training Type-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Type-1")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _hoisted_39,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Training Name",
                  modelValue: _ctx.batch.training_name,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.batch.training_name) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "training-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("training-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "training-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("training-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "training-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("training-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "training-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("training-1")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _hoisted_42,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Training Trade",
                  modelValue: _ctx.batch.training_trade,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.batch.training_trade) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Training Trade-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Trade-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Training Trade-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Trade-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Training Trade-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Trade-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Training Trade-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Trade-1")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _hoisted_45,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Training Sector",
                  modelValue: _ctx.batch.training_sector,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.batch.training_sector) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Training Sector-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Sector-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Training Sector-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Sector-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Training Sector-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Sector-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Training Sector-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Sector-1")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _hoisted_49,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Training Sector",
                  modelValue: _ctx.batch.training_package,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.batch.training_package) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Training Package-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Package-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Training Package-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Package-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Training Package-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Package-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Training Package-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Package-1")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _hoisted_50,
              _createTextVNode(" . ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "submit",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.alertSuccess())),
          class: "btn btn-primary text-center"
        }, " Submit ")
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}